import { ChangeDetectionStrategy, Component } from '@angular/core'
import { DesktopUpdateSplashComponent } from '@ftr/ui-desktop'

@Component({
  selector: 'ftr-desktop-update-splash-page',
  template: '<ftr-desktop-update-splash />',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [DesktopUpdateSplashComponent],
})
export class DesktopUpdateSplashPage {}
